
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/liquidity/open-position/[pool-address]",
      function () {
        return require("private-next-pages/liquidity/open-position/[pool-address].nemo.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/liquidity/open-position/[pool-address]"])
      });
    }
  